/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../../common/header/Header";
import Footer from "../../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      h2: "h2",
      h3: "h3",
      ol: "ol",
      li: "li",
      ul: "ul",
      em: "em"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | How we handle abusive usage"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "How we handle abusive usage"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsx(_components.p, {
                    children: "We build our products to give teams a better way to work. We are proud of that purpose and\ntrust that our customers use our products for appropriate endeavors."
                  }), _jsxs(_components.p, {
                    children: ["Sometimes, though, we discover potential abusive usage as detailed in our ", _jsx(_components.a, {
                      href: "./",
                      children: "Use Restrictions\npolicy"
                    }), ". When that happens, we investigate using the following guiding\nprinciples and process."]
                  }), _jsx(_components.h2, {
                    children: "Guiding Principles"
                  }), _jsx(_components.h3, {
                    children: "Human oversight"
                  }), _jsx(_components.p, {
                    children: "Who’s “we”, you ask? It’s us: folks from the Modulabs team. Our internal abuse oversight\ncommittee includes our executives, and representatives from multiple\ndepartments across the company. On rare occasions for particularly sensitive situations or\nif legally required, we may also seek counsel from external experts."
                  }), _jsx(_components.h3, {
                    children: "Balanced responsibilities"
                  }), _jsx(_components.p, {
                    children: "We have an obligation to protect the privacy and safety of both our customers and the people\nreporting issues to us. We do our best to balance those responsibilities throughout the\nprocess."
                  }), _jsx(_components.h3, {
                    children: "Focus on evidence"
                  }), _jsx(_components.p, {
                    children: "We base our decisions on the evidence available to us: what we see and hear account users\nsay and do. We document what we observe and ask whether that observable evidence points to a\nrestricted use."
                  }), _jsx(_components.h2, {
                    children: "Process"
                  }), _jsx(_components.p, {
                    children: "Every case goes through the same general process:"
                  }), _jsxs(_components.ol, {
                    children: ["\n", _jsx(_components.li, {
                      children: "Discovery"
                    }), "\n", _jsx(_components.li, {
                      children: "Investigation"
                    }), "\n", _jsx(_components.li, {
                      children: "Decision, sometimes with right to an appeal"
                    }), "\n"]
                  }), _jsx(_components.h3, {
                    children: "How do we discover potential abuse?"
                  }), _jsx(_components.p, {
                    children: "From our experience, we learn about potential abuse because:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsxs(_components.li, {
                      children: ["Someone alerts us. We give ", _jsx(_components.a, {
                        href: ".",
                        children: "abuse reports"
                      }), " our full care and attention. Our\nSupport team also responds to every question or comment that comes in. If we notice anything\nin those emails that points to a violation, we will look into it."]
                    }), "\n", _jsx(_components.li, {
                      children: "We notice an anomaly in our business operations monitoring. We monitor a range of things\nabout our products, like signup volume and error rates of web requests. If we see something\nweird with those numbers, we get to the bottom of it."
                    }), "\n", _jsx(_components.li, {
                      children: "We stumble upon public web content that links an individual or organization to a Modulabs\nproduct. We aren’t scouring the Internet looking for those links, but if we do come across\nany, we check them out."
                    }), "\n"]
                  }), _jsx(_components.p, {
                    children: "This list is not exhaustive; there are always edge cases. We will update the list if we find\nregular new avenues."
                  }), _jsx(_components.h3, {
                    children: "How do we investigate?"
                  }), _jsx(_components.p, {
                    children: "We focus on the evidence:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "Language and imagery used by users on the account"
                    }), "\n", _jsx(_components.li, {
                      children: "Evidence of account users’ power and/or ability to act on spoken claims"
                    }), "\n", _jsx(_components.li, {
                      children: "Publicly available information about account users"
                    }), "\n"]
                  }), _jsx(_components.p, {
                    children: "We strive to balance privacy and safety for all those involved:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "We make every effort to complete our investigations without accessing a customer account.\nFor instance, if there are screenshots or public documents available, we review those. We\nalso consider whether it is appropriate to involve the account owner in a given\ninvestigation and seek additional evidence from them."
                    }), "\n", _jsx(_components.li, {
                      children: "As we review the evidence, we look for indications of existing negative impact. We also\nassess the severity of any potential negative impact, regardless of intent. When relevant,\nwe look for and follow available guidelines from expert institutions."
                    }), "\n", _jsx(_components.li, {
                      children: "If we cannot come to a fair assessment from the information available, we may decide to\naccess a customer account without notice. We do not make this decision lightly. Customer\nprivacy is a big deal to us and we only pursue this course of action if the evidence we have\nalready is very concerning, but not definitive."
                    }), "\n"]
                  }), _jsx(_components.p, {
                    children: "While some violations are flatly obvious, others are subjective, nuanced, and difficult to\nadjudicate. We give each case adequate time and attention, commensurate with the violation,\ncriticality, and severity of the charge."
                  }), _jsx(_components.h3, {
                    children: "What happens if someone really broke the rules?"
                  }), _jsx(_components.p, {
                    children: "We will terminate an account without advance notice if there is evidence it is being used\nfor a restricted purpose that has, is, or will cause severe harm. If applicable, we will\nalso report the incident to the appropriate authorities."
                  }), _jsx(_components.p, {
                    children: "For other cases, we’ll take a case-by-case approach to clear things up."
                  }), _jsx(_components.p, {
                    children: "Further, as a small, privately owned independent business that puts our values and\nconscience ahead of growth at all costs, we reserve the right to deny service to anyone we\nultimately feel uncomfortable doing business with."
                  }), _jsx(_components.h3, {
                    children: "Can you appeal a decision?"
                  }), _jsx(_components.p, {
                    children: "If we terminate an account without notice, the decision is final."
                  }), _jsxs(_components.p, {
                    children: ["For other cases, we will consider good faith appeals sent to\n", _jsx(_components.a, {
                      href: "mailto:appeals@modulabs.io",
                      children: "appeals@modulabs.io"
                    }), " by the account owner within 14 calendar\ndays."]
                  }), _jsxs(_components.p, {
                    children: ["*", _jsx(_components.em, {
                      children: "This process applies to any product created and owned by Modulabs, LLC."
                    })]
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
